var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.66667 7.33333C6.05625 7.33333 6.38976 7.19462 6.66719 6.91719C6.94462 6.63976 7.08333 6.30625 7.08333 5.91667C7.08333 5.52708 6.94462 5.19358 6.66719 4.91615C6.38976 4.63872 6.05625 4.5 5.66667 4.5C5.27708 4.5 4.94358 4.63872 4.66615 4.91615C4.38871 5.19358 4.25 5.52708 4.25 5.91667C4.25 6.30625 4.38871 6.63976 4.66615 6.91719C4.94358 7.19462 5.27708 7.33333 5.66667 7.33333ZM5.66667 12.5396C7.10695 11.2174 8.17535 10.0161 8.87188 8.93594C9.5684 7.85573 9.91667 6.89653 9.91667 6.05833C9.91667 4.77153 9.50642 3.71788 8.68594 2.8974C7.86545 2.07691 6.85903 1.66667 5.66667 1.66667C4.47431 1.66667 3.46788 2.07691 2.6474 2.8974C1.82691 3.71788 1.41667 4.77153 1.41667 6.05833C1.41667 6.89653 1.76493 7.85573 2.46146 8.93594C3.15799 10.0161 4.22639 11.2174 5.66667 12.5396ZM5.66667 14.4167C3.76597 12.7993 2.34635 11.297 1.40781 9.9099C0.469271 8.52274 0 7.23889 0 6.05833C0 4.2875 0.569618 2.87674 1.70885 1.82604C2.84809 0.775347 4.16736 0.25 5.66667 0.25C7.16597 0.25 8.48524 0.775347 9.62448 1.82604C10.7637 2.87674 11.3333 4.2875 11.3333 6.05833C11.3333 7.23889 10.8641 8.52274 9.92552 9.9099C8.98698 11.297 7.56736 12.7993 5.66667 14.4167Z",
    fill: "#F04D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.3438e8e60070cff33d6b0a51972ca7e5.svg";
export { ForwardRef as ReactComponent };